import React, { useState } from 'react';
import { Sparkles, Send, ThumbsUp, ThumbsDown } from 'lucide-react';

const AIAssistantPanel = ({ worksheet, activeTab }) => {
  const [messages, setMessages] = useState([
    {
      role: 'assistant',
      content: 'Hello! I can help you identify hazards based on your equipment and work activities. What would you like assistance with?'
    }
  ]);
  const [inputMessage, setInputMessage] = useState('');

  const handleSendMessage = () => {
    if (!inputMessage?.trim()) return;

    setMessages([
      ...messages,
      { role: 'user', content: inputMessage },
      {
        role: 'assistant',
        content: 'Based on the equipment tag HE-101 (Heat Exchanger), I\'ve identified several potential hazards:\n\n1. **High Temperature Exposure** - During maintenance, residual heat can cause burns\n2. **Chemical Exposure** - Process fluids may be corrosive or toxic\n\nWould you like me to add these to your HAZID worksheet?'
      }
    ]);
    setInputMessage('');
  };

  return (
    <div className="w-96 bg-white border-l border-gray-200 flex flex-col">
      {/* Header */}
      <div className="p-4 border-b border-gray-200">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-purple-50 rounded-lg">
            <Sparkles className="w-5 h-5 text-purple-600" />
          </div>
          <div>
            <h3 className="font-semibold text-gray-900">AI Assistant</h3>
            <p className="text-xs text-gray-600">Hazard identification support</p>
          </div>
        </div>
      </div>
      {/* Messages */}
      <div className="flex-1 overflow-y-auto p-4 space-y-4">
        {messages?.map((message, index) => (
          <div
            key={index}
            className={`flex ${message?.role === 'user' ? 'justify-end' : 'justify-start'}`}
          >
            <div
              className={`max-w-[80%] rounded-lg p-3 ${
                message?.role === 'user' ?'bg-blue-600 text-white' :'bg-gray-100 text-gray-900'
              }`}
            >
              <p className="text-sm whitespace-pre-wrap">{message?.content}</p>
              {message?.role === 'assistant' && (
                <div className="flex gap-2 mt-2 pt-2 border-t border-gray-200">
                  <button className="p-1 hover:bg-gray-200 rounded">
                    <ThumbsUp className="w-3 h-3" />
                  </button>
                  <button className="p-1 hover:bg-gray-200 rounded">
                    <ThumbsDown className="w-3 h-3" />
                  </button>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
      {/* Input */}
      <div className="p-4 border-t border-gray-200">
        <div className="flex gap-2">
          <input
            type="text"
            value={inputMessage}
            onChange={(e) => setInputMessage(e?.target?.value)}
            onKeyPress={(e) => e?.key === 'Enter' && handleSendMessage()}
            placeholder="Ask about hazards..."
            className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 text-sm"
          />
          <button
            onClick={handleSendMessage}
            className="p-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700"
          >
            <Send className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default AIAssistantPanel;